export const getIdFromUrl = (url) => {
  return Number(url.split('_').slice(-1)[0]);
};
